import { Suspense } from 'react'
import { isDesktop } from 'react-device-detect';

export default function LayoutLogin({children}) {

  const Children = children;

  return (
    <Suspense fallback={'Cargando...'}>
      <div className={isDesktop ? 'uiDesktop':'uiMobile'}>
        <Children/>
      </div>
    </Suspense>
  )
}
